import React, { useEffect, useState } from "react";
import "./TrendingProducts.scss";
import { Button, Form, Modal, Spin, message } from "antd";
import { FormMultiSelect } from "../FormInputs/FormSelect";
import { deleteApi, getApi, postApi } from "../../utils/apiServices";
import {
  ADD_TRENDING_PRODUCT,
  DELETE_TRENDING_PRODUCT,
  GET_PRODUCTS_VARIENTS_LIST_DROPDOWN,
  GET_TRENDING_PRODUCTS,
} from "../../utils/apiPath";
import { IMAGE_BASE_PATH } from "../../utils/constant";
import { CloseOutlined } from "@ant-design/icons";
import { spinContent } from "../../services/customData";
import ToastHelper from "../../services/ToastHelper";

const TrendingProducts = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const [trendingProductsList, setTrendingProductsList] = useState([]);
  const [filteredProductsList, setFilteredProductsList] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const payload = { productVariantIds: values?.products };
      const res = await postApi(`${ADD_TRENDING_PRODUCT}`, payload);
      setLoading(false);
      message.success("Category topic items added successfully");
      form.resetFields();
      setIsModalOpen(false);
      getTrendingProductsList();
    } catch (error) {
      console.error("Validation Error:", error);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  useEffect(() => {
    getProductsList();
    getTrendingProductsList();
  }, []);

  const getTrendingProductsList = async () => {
    setLoading(true);
    try {
      const res = await getApi(`${GET_TRENDING_PRODUCTS}`);
      setTrendingProductsList(res?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching topic items", error);
    }
  };

  const getProductsList = async () => {
    setLoading(true);
    try {
      const res = await getApi(`${GET_PRODUCTS_VARIENTS_LIST_DROPDOWN}`);
      setProductsList(
        res?.map((item) => ({
          label: `${item?.productName} (${item?.color})`,
          value: item?.productVariantId,
        }))
      );
      setLoading(false);
    } catch (error) {
      console.error("Error fetching topic items", error);
    }
  };

  useEffect(() => {
    if (productsList && trendingProductsList) {
      const filteredProducts = productsList.filter(
        (item) => !trendingProductsList.some((val) => val.id === item.value)
      );
      setFilteredProductsList(filteredProducts);
    } else {
      setFilteredProductsList(productsList);
    }
  }, [productsList, trendingProductsList]);

  const handleDeleteModal = (item) => {
    setDeleteItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setDeleteItem(null);
    setOpen(false);
  };

  const handleDeleteProduct = async () => {
    try {
      const res = await deleteApi(
        `${DELETE_TRENDING_PRODUCT}?trendingProductId=${deleteItem?.trendingProductId}`
      );

      if (res?.statusCode === 200) {
        ToastHelper.success("Trending product deleted successfully");
        handleClose();
        getTrendingProductsList();
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="t-products">
      <div className="t-products_container">
        <div className="t-products_header">
          <div className="t-products_header_left">
            <h2>Trending Products</h2>
          </div>
          <div className="t-products_header_right">
            <Button type="primary" onClick={showModal}>
              Add
            </Button>
          </div>
        </div>
        <div className="t-products_sections">
          <div className="t-products_cards">
            {trendingProductsList?.length > 0 &&
              trendingProductsList?.map((topic, index) => {
                return (
                  <div key={index} className="t-products_card">
                    <div className="t-products_card_image">
                      <img
                        src={`${IMAGE_BASE_PATH}${topic?.productVariantMedia?.mediaUrl}`}
                        alt=""
                      />
                      <div
                        className="t-products_card_close"
                        onClick={() => handleDeleteModal(topic)}
                      >
                        <CloseOutlined />
                      </div>
                    </div>
                    <div className="t-products_card_content">
                      <h3>
                        {topic?.title} ({topic?.color})
                      </h3>
                    </div>
                  </div>
                );
              })}
          </div>
          {loading ? (
            <div className="t-products_loading">
              <Spin tip="Loading">{spinContent}</Spin>
            </div>
          ) : (
            trendingProductsList?.length === 0 && (
              <h5>No trending products available</h5>
            )
          )}
        </div>
      </div>
      <Modal
        title="Add"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered={true}
        maskClosable={false}
      >
        <div className="t-product_modal">
          <Form form={form} layout="vertical">
            <FormMultiSelect
              label="Select products"
              name="products"
              placeholder="Select products"
              rules={[{ required: true }]}
              options={filteredProductsList}
              mode="multiple"
            />
          </Form>
        </div>
      </Modal>
      <Modal
        title="Confirm"
        open={open}
        onOk={handleDeleteProduct}
        onCancel={handleClose}
        width={300}
      >
        <p>Are you sure want to delete?</p>
      </Modal>
    </div>
  );
};

export default TrendingProducts;
